import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const OptionsIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.9995 2C13.9995 3.10457 13.1041 4 11.9995 4C10.8949 4 9.99951 3.10457 9.99951 2C9.99951 0.895431 10.8949 0 11.9995 0C13.1041 0 13.9995 0.895431 13.9995 2ZM13.9995 12C13.9995 13.1046 13.1041 14 11.9995 14C10.8949 14 9.99951 13.1046 9.99951 12C9.99951 10.8954 10.8949 10 11.9995 10C13.1041 10 13.9995 10.8954 13.9995 12ZM11.9995 24C13.1041 24 13.9995 23.1046 13.9995 22C13.9995 20.8954 13.1041 20 11.9995 20C10.8949 20 9.99951 20.8954 9.99951 22C9.99951 23.1046 10.8949 24 11.9995 24Z'
      />
    </svg>
  );
};
